export function createSlug(str) {
    return String(str)
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9 -]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
}


export function generateUrl(swatch, car, basePath = '') {
    const normalizedBasePath = basePath ? `/${basePath}` : '';
    const slug = createSlug(`${car.brand}-${car.model}-${car.trim}-${car.id}`);
    return `${normalizedBasePath}/${slug}?color=${swatch.id}`;
}




/**
 * Normaliseert het basePath vanuit een data-attribuut.
 *
 * - Verwijdert leading/trailing slashes
 * - Houdt "renault/private-lease" volledig intact
 * - Converteert alle andere paden naar enkel het laatste segment
 * - Retourneert altijd een string zonder leading slash
 *
 * Voorbeeld:
 *  "/private-lease/"         → "private-lease"
 *  "private-lease"           → "private-lease"
 *  "renault/private-lease"   → "renault/private-lease"
 *  "/renault/private-lease/" → "renault/private-lease"
 *
 * @param {string|null|undefined} basePath
 * @returns {string}
 */
export function normalizeBasePath(basePath) {
    if (!basePath || typeof basePath !== 'string') return '';

    let cleaned = basePath.trim();

    // Verwijder leading en trailing slashes
    cleaned = cleaned.replace(/^\/+/, '').replace(/\/+$/, '');

    // Retourneer het volledige pad (zonder te strippen naar laatste segment)
    return cleaned;
}


